"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBreadcrumb = void 0;
const toBreadcrumb = function (path) {
    return path.join('.');
};
exports.toBreadcrumb = toBreadcrumb;
